import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PerformanceAuditMatrix from "../../../components/TalentMatrix/PerformanceAuditMatrix";
import AgileMatrixHeatmap from "../../../components/TalentMatrix/AgileMatrixHeatmap";
import { useAgileMatrix } from "../../../Hooks/Features/TalentMatrix/useAgileMatrix";
import CommonFilterDropdown from "../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { useCommon } from "../../../Hooks/Common/useCommon";

const AgileMatrix = () => {

  const {getValuePermission} = useCommon();
  const { options, filterValues, setFilterValues } = useAgileMatrix();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  return ( !getValuePermission("agile_matrix_tab") &&
    <div>
      <div className="d-flex justify-content-between align-items-center my-2 gap-3 px-3">
        <div className="d-flex gap-2 align-items-center flex-grow-1">
          <h5 className="mb-0 text-nowrap">Agile Matrix</h5>
        </div>
        <div className="d-flex justify-content-end align-items-center gap-2">
          <button className="sk-btn sk-btn-primary rounded" title="Refresh" onClick={() => setFilterValues((prev) => ({ ...prev, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
          <button className="sk-btn sk-btn-primary rounded" title="Filters" onClick={() => setShowFiltersDrawer(true)}><FontAwesomeIcon icon="fa-solid fa-filter" /></button>
        </div>
      </div>
      <div className="pb-3">
        <div className="shadow-sm border m-3">
          <AgileMatrixHeatmap options={options} filterValues={filterValues} setFilterValues={setFilterValues} />
        </div>
        <div className="shadow-sm border m-3">
          <PerformanceAuditMatrix options={options} filterValues={filterValues} setFilterValues={setFilterValues} />
        </div>
      </div>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setFilterValues({
                  ...filterValues,
                  months: [],
                  projects: [],
                  users: [],
                  project_leads: [],
                  project_role: [],
                  isChange: true
                });
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Month Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Month</div>
                <MultiSelect options={options?.months} placeholder="Month" value={filterValues?.months} onChange={(e) => setFilterValues((prev) => ({...prev, months: e.target?.value, isChange: true}))} onHide={() => {if(filterValues?.isChange) {setFilterValues((prev) => ({...prev, apiCall: true, isChange: false}))}}} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "months", filterValues?.months, () => setFilterValues((prev) => ({ ...prev, months: [], isChange: true })))} maxSelectedLabels={1} selectedItemsLabel="{0} months" className="sk-input-dd w-100"/>
              </div>

              {/* Core Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Core Filters</div>
                <CommonFilterDropdown fields={[{ key: "projects", label: "Projects", col: 12 }, { key: "users", label: "Users", col: 12 }, { key: "project_leads", label: "Leads", col: 12 }, filterValues?.projects?.length > 0 ? { key: "project_role", label: "Roles", col: 12 } : null]} filterValues={filterValues} setFilterValues={setFilterValues} />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              setFilterValues((prev) => ({ ...prev, apiCall: true }));
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgileMatrix